import React from "react";
import styles from "../../assets/scss/pagesScss/home.module.scss"; // Add your SCSS styles
import { services } from "../../assets/config/config";

export default function ServiceSections() {
    return (
        <section className={styles.services} id="services"> 
            <div className="container">
                <div className={styles.servicesSection} >
                    <div className={styles.servicesHeader}>
                        <div>
                            <h6 className={styles.subtitle}>OUR SERVICES</h6>
                            <h2 className={styles.title}>Reliable Electricians Powering Your Everyday Needs</h2>

                        </div>
                        <p className={styles.description}>
                            From residential households to commercial enterprises, we provide reliable, efficient, and sustainable energy solutions.
                        </p>
                    </div>

                    <div className={styles.servicesGrid}>
                        {services.map((service) => (
                            <div key={service.id} className={styles.serviceCard}>
                                <img src={service.image} alt={service.title} className={styles.serviceImage} />
                                <div className={styles.serviceContent}>
                                    <h3>{service.title}</h3>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
